export const API_URL = `https://dashapi.bet-gulf.com`;
export const CLOUD_URL = `https://cloud.bet-gulf.com/Storage`;
export const UPLOAD_URL = `https://upload.bet-gulf.com/UploadImage`;

export const USER_URL = `${API_URL}/User`;
export const STATIC_URL = `${API_URL}/Static`;
export const BETTING_WEBSITE_RELATIVES_URL = `${API_URL}/BettingWebsite/Relatives`;
export const BETTING_WEBSITE_URL = `${API_URL}/BettingWebsite`;
export const ARTICLE_URL = `${API_URL}/Articles`;
export const TOP10_ARTICLE_URL = `${API_URL}/Top10Articles`;
export const MAIN_WEBSITES_URL = `${API_URL}/MainWebsite`;

export const PAYMENT_METHOND_CLOUD_URL = `${CLOUD_URL}/PaymentMethods/`;
